import React, { useState, useEffect } from 'react';
import { useLanguage } from '../utils/LanguageContext';
import Map from './Map';
import { createLocation, getLocations, voteLocation, Location } from '../utils/api';
import PinnedLocationsAccordion from './PinnedLocationsAccordion';

const WhereShouldWeGo: React.FC = () => {
    const { t } = useLanguage();
    const [locations, setLocations] = useState<Location[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        // Load existing locations when component mounts
        const loadLocations = async () => {
            try {
                const loadedLocations = await getLocations();
                setLocations(loadedLocations);
            } catch (err) {
                setError(t('location.error.loading'));
            }
        };
        loadLocations();
    }, [t]);

    const handlePlaceSelect = async (place: { name: string; address: string; location: { lat: number; lng: number } }) => {
        try {
            const newLocation = await createLocation({
                ...place,
                votes: 0
            });
            setLocations(prevLocations => [...prevLocations, newLocation]);
            setError(null);
        } catch (err) {
            setError(t('location.error.create'));
        }
    };

    const handleVote = async (locationId: number) => {
        try {
            await voteLocation(locationId);
            const updatedLocations = await getLocations();
            setLocations(updatedLocations);
            setError(null);
        } catch (err) {
            setError(t('location.error.vote'));
        }
    };

    return (
        <div className="location-section">
            <h2>{t('location.title')}</h2>
            {error && <div className="error-message">{error}</div>}
            <div className="location-content">
                <Map onPlaceSelect={handlePlaceSelect} />
                <div className="pinned-locations">
                    <h3>{t('location.suggested')}</h3>
                    <PinnedLocationsAccordion 
                        locations={locations} 
                        onVote={handleVote} 
                    />
                </div>
            </div>
        </div>
    );
};

export default WhereShouldWeGo;